import { Component, OnInit } from '@angular/core';
import { SelectOption, SsoProvider } from '@core/types';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
    selector: 'sso-option-modal',
    templateUrl: './sso-option.component.html',
    styleUrls: ['./sso-option.component.scss'],
    standalone: false
})
export class SsoOptionComponent {

    /**
     * constructor
     * 
     * @param {NgbActiveModal} activeModal 
     */
    constructor(private _ngbActiveModal: NgbActiveModal) { }

    /**
     * get SsoProvider
     */
    get SsoProvider() {
        return SsoProvider;
    }

    /**
     * output close with key
     * 
     * @param key 
     */
    public close(key): void {
        this._ngbActiveModal.close(key);
    }
}